import type { CmsProps } from '../../types/cms'
import styled from '@emotion/styled'

export const Title = styled.h2<CmsProps>`
  color: #fff;
  text-align: center;
  margin-bottom: 2rem;
`
